import { Link } from 'react-router-dom';
import Navbar from '../components/feature/Navbar';
import Footer from '../components/feature/Footer';
import SEO from '../components/SEO';

export default function NotFound() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO
        title="404 - Page Not Found | Anime HOT or NOT"
        description="The page you're looking for doesn't exist. Return to Anime HOT or NOT to rate your favorite anime characters."
        keywords="anime, 404, page not found"
        canonical={`${siteUrl}/404`}
      />
      
      <Navbar />

      <main className="flex-grow flex items-center justify-center px-4 py-20">
        <div className="max-w-2xl mx-auto text-center">
          {/* 404 Illustration */}
          <div className="mb-8">
            <div className="relative inline-block">
              <div className="text-9xl font-bold bg-gradient-to-r from-pink-500 to-purple-600 bg-clip-text text-transparent">
                404
              </div>
              <div className="absolute -top-4 -right-4 w-16 h-16 flex items-center justify-center">
                <i className="ri-emotion-sad-line text-6xl text-pink-500 animate-pulse"></i>
              </div>
            </div>
          </div>

          {/* Error Message */}
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Oops! Character Not Found
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            Looks like this anime character wandered off to another dimension. The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link
              to="/"
              className="px-8 py-4 text-base font-semibold text-white bg-gradient-to-r from-pink-500 to-purple-600 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap"
            >
              <i className="ri-home-4-line mr-2"></i>
              Back to Home
            </Link>
            <Link
              to="/rate"
              className="px-8 py-4 text-base font-semibold text-gray-900 bg-white border-2 border-gray-300 rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap"
            >
              <i className="ri-heart-line mr-2"></i>
              Start Rating
            </Link>
          </div>

          {/* Quick Links */}
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8">
            <h2 className="text-xl font-bold text-gray-900 mb-4">
              Popular Pages
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <Link
                to="/top10"
                className="flex flex-col items-center p-4 bg-white rounded-xl hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-full mb-2">
                  <i className="ri-trophy-line text-2xl text-pink-500"></i>
                </div>
                <span className="text-sm font-semibold text-gray-900">Top 10</span>
              </Link>

              <Link
                to="/all-series"
                className="flex flex-col items-center p-4 bg-white rounded-xl hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mb-2">
                  <i className="ri-tv-line text-2xl text-purple-500"></i>
                </div>
                <span className="text-sm font-semibold text-gray-900">All Series</span>
              </Link>

              <Link
                to="/favorites"
                className="flex flex-col items-center p-4 bg-white rounded-xl hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-pink-100 rounded-full mb-2">
                  <i className="ri-heart-fill text-2xl text-pink-500"></i>
                </div>
                <span className="text-sm font-semibold text-gray-900">Favorites</span>
              </Link>

              <Link
                to="/top5users"
                className="flex flex-col items-center p-4 bg-white rounded-xl hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-full mb-2">
                  <i className="ri-user-star-line text-2xl text-purple-500"></i>
                </div>
                <span className="text-sm font-semibold text-gray-900">Top Users</span>
              </Link>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
